<template>
  <div
    class="flex w-full justify-between items-center"
    :class="{ 'mb-3': isTitle || btnPos == 'top' }"
  >
    <div class="max-md:px-5 max-md:pt-5" v-if="isTitle">
      <p>Add suite to your worksheet:</p>
    </div>
    <div
      v-if="btnPos == 'top'"
      class="max-md:fixed max-md:bottom-0 max-md:w-full gap-4 max-md:px-9 max-md:border-t max-md:border-mainBlack-300 max-md:bg-white box-border max-md:py-5 max-md:flex max-md:justify-end max-md:items-center z-150"
    >
      <button class="underline md:mr-6" @click="$emit('close')">Cancel</button>
      <button
        class="bg-mainBlack-1000 rounded-[30px] text-white py-3 px-11"
        @click="$emit('save', worksheetId)"
      >
        Save
      </button>
    </div>
  </div>
  <div class="max-md:px-5 w-full">
    <popupHeader
      v-if="floorplanList.length"
      :sortType="sortType"
      :sortStyle="sortStyle"
      :models="floorplanList"
      @handleCheckboxChange="handleCheckboxChange"
      @filterModels="getFilteredData"
      @handleSortType="getSortType"
      @handleSortStyle="getSortStyle"
    >
    </popupHeader>
  </div>
  <div
    class="flex max-md:px-5 flex-wrap mt-9 mb-6 gap-4"
    :class="classSelection"
  >
    <p class="mr-2 text-mainBlack-400">Selection:</p>
    <div class="flex gap-2" v-for="(item, index) in worksheetId" :key="index">
      <img
        src="@/assets/icons/svg/worksheet/delete.svg"
        class="cursor-pointer"
        @click="deleteUnit(item)"
      />
      <p class="">Suite {{ item.name }}</p>
      <p
        class="pl-2 text-mainBlack-300"
        v-if="index !== worksheetId.length - 1"
      >
        |
      </p>
    </div>
  </div>
  <div
    class="max-md:px-5 max-md:pb-28 floorplans tablePopupWorksheet mt-3 pb-6"
  >
    <div v-if="filteredModels.length == 0 && loading">
      <TableSkeleton />
    </div>
    <div v-else class="vgt-wrap sm:mx-0 mx-auto w-full">
      <div class="vgt-inner-wrap max-md:hidden">
        <div
          class="vgt-responsive !pt-0 h-[68vh] md:h-[calc(100vh_-_20.5rem)] hide-scrollbar !overflow-x-auto !overflow-auto"
        >
          <table
            id="vgt-table"
            class="vgt-table bordered !border-spacing-0 h-fit"
          >
            <colgroup>
              <col id="col-0" />
              <col id="col-1" />
              <col id="col-2" />
              <col id="col-3" />
              <col id="col-4" />
              <col id="col-5" />
              <col id="col-6" />
              <col id="col-7" />
              <col id="col-8" />
            </colgroup>
            <thead class="">
              <tr class="">
                <th
                  scope="col"
                  class="webkit-sticky !sticky !bg-qooWhite-5 !rounded-none -top-px vgt-left-align !py-4"
                  aria-sort="descending"
                  aria-controls="col-8"
                  style="min-width: auto; width: auto"
                >
                  <span></span>
                </th>
                <th
                  scope="col"
                  class="webkit-sticky !sticky !bg-qooWhite-5 -top-px vgt-left-align !py-4"
                  aria-sort="descending"
                  aria-controls="col-0"
                  style="min-width: auto; width: auto"
                >
                  <span>Model</span>
                </th>
                <th
                  scope="col"
                  class="webkit-sticky !sticky !bg-qooWhite-5 -top-px vgt-left-align"
                  aria-sort="descending"
                  aria-controls="col-1"
                  style="min-width: auto; width: auto"
                >
                  <span>Type</span>
                </th>
                <th
                  scope="col"
                  class="webkit-sticky !sticky !bg-qooWhite-5 -top-px vgt-left-align"
                  aria-sort="descending"
                  aria-controls="col-2"
                  style="min-width: auto; width: auto"
                >
                  <span>Area</span>
                </th>
                <th
                  scope="col"
                  class="webkit-sticky !sticky !bg-qooWhite-5 -top-px vgt-left-align"
                  aria-sort="descending"
                  aria-controls="col-3"
                  style="min-width: auto; width: auto"
                >
                  <span>Bathrooms</span>
                </th>
                <th
                  scope="col"
                  class="webkit-sticky !sticky !bg-qooWhite-5 -top-px vgt-left-align"
                  aria-sort="descending"
                  aria-controls="col-5"
                  style="min-width: auto; width: auto"
                >
                  <span>Price</span>
                </th>
                <th
                  scope="col"
                  class="webkit-sticky !sticky !bg-qooWhite-5 !rounded-none -top-px vgt-left-align"
                  aria-sort="descending"
                  aria-controls="col-7"
                  style="min-width: auto; width: auto"
                >
                  <span>Availability</span>
                </th>
              </tr>
            </thead>
            <tbody>
              <template v-for="(item, index) in filteredModels">
                <tr
                  v-if="true"
                  :key="index"
                  :class="{
                    'change-bg': p.selected > -1 && index !== p.selected,
                  }"
                >
                  <td
                    class="vgt-left-align !py-6 !pl-8 transition-all ease-in duration-200"
                    :class="{ '!rounded-bl-none': index === p.selected }"
                  >
                    <span
                      @click="handleModelSelect(index, item)"
                      class="cursor-pointer"
                    >
                      <img
                        class="max-w-none"
                        src="@/assets/icons/svg/worksheet/PlusTable.svg"
                        v-if="index !== p.selected"
                      />
                      <img
                        src="@/assets/icons/svg/worksheet/Plus.svg"
                        v-if="index === p.selected"
                      />
                    </span>
                  </td>
                  <td class="vgt-left-align !py-6">
                    <span>{{ item.modelName || "-" }}</span>
                  </td>
                  <td class="vgt-left-align !py-6">
                    <span>{{ item.specDescription || "-" }}</span>
                  </td>
                  <td class="vgt-left-align !py-6">
                    <span>{{ item.modelSize || "-" }}</span>
                  </td>
                  <td class="vgt-left-align !py-6">
                    <span>{{ item.bathNumber || "-" }}</span>
                  </td>
                  <td class="vgt-left-align !py-6">
                    <span>
                      {{
                        item?.units?.length != 0
                          ? Math.min(...item?.units?.map((item) => +item.price))
                            ? Math.min(
                                ...item?.units?.map((item) => +item.price),
                              ).toLocaleString("en-CA", {
                                style: "currency",
                                currency: "CAD",
                                maximumFractionDigits: 0,
                              })
                            : "-"
                          : "-"
                      }}
                    </span>
                    <!-- <span>-</span> -->
                  </td>
                  <td
                    class="vgt-left-align !py-6 !justify-start"
                    :class="{ '!rounded-br-none ': index === p.selected }"
                  >
                    <span>
                      {{ item.units.length }}
                    </span>
                  </td>
                </tr>
                <tr
                  v-if="index === p.selected"
                  :key="index"
                  class="!w-full !border-t !border-qooWhite-60"
                >
                  <td
                    colspan="100%"
                    class="!pt-0 !table-cell !rounded-[10px] !rounded-t-none"
                  >
                    <div
                      class="grid sm:grid-cols-2 grid-cols-2 gap-2 flex-wrap !pt-4 !border-t !border-qooWhite-2"
                    >
                      <div
                        class="bg-qooWhite-5 rounded-lg px-2 py-3 w-full"
                        v-for="(i, j) in item.units"
                        :key="j + '-unit'"
                      >
                        <div class="flex gap-2 justify-between">
                          <ul
                            class="flex items-center w-full justify-between flex-wrap gap-2"
                          >
                            <li>
                              <div class="text-xs text-mainBlack-300">
                                Suite:
                              </div>
                              <div class="text-sm">{{ i.suiteName }}</div>
                            </li>
                            <li>
                              <div class="text-xs text-mainBlack-300">
                                Orientation:
                              </div>
                              <div class="text-sm">
                                {{ i.orientationAbbreviation }}
                              </div>
                            </li>
                            <li>
                              <div class="text-xs text-mainBlack-300">
                                Price:
                              </div>
                              <div class="text-sm">
                                {{
                                  i.price?.toLocaleString("en-US")
                                    ? "$" + i.price?.toLocaleString("en-US")
                                    : "-"
                                }}
                              </div>
                            </li>
                          </ul>
                          <div class="w-[127px]">
                            <!-- <lightBtn
                              :disabled="i.status == 'Sold'"
                              @clickBtn="addWSH(item.modelId, i.suiteId)"
                              classList="px-4 py-2"
                              :text="
                                worksheetId.findIndex(
                                  (worksheet) =>
                                    worksheet.Mid === item.modelId &&
                                    worksheet.Uid === i.suiteId,
                                ) == -1
                                  ? 'Add Suite'
                                  : 'Remove Suite'
                              "
                            >
                            </lightBtn> -->
                            <EnhancedButton
                              type="outlined"
                              :disabled="UnauthorizedStatus(item.statusDesc)"
                              class="w-[105px] h-[36px] text-[14px] !px-0"
                              :text="
                                UnauthorizedStatus(item.statusDesc)
                                  ? 'Add Suite'
                                  : !buttonStates[i.suiteId]
                                    ? 'Remove Suite'
                                    : 'Add Suite'
                              "
                              @click="
                                addWSH(
                                  selectedModelForWorksheet.modelId,
                                  i.suiteId,
                                  item,
                                )
                              "
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </td>
                </tr>
                <tr v-if="true" :key="index">
                  <th class="!p-1"></th>
                </tr>
              </template>
            </tbody>
          </table>
        </div>
      </div>
      <div
        class="md:hidden card bg-qooWhite-5 border flex flex-col gap-2 h-[calc(100vh_-_19.5rem)] hide-scrollbar overflow-auto border-qooWhite-2 rounded-xl p-3"
      >
        <div
          class="bg-white rounded-xl px-6 py-4"
          :class="{ 'change-bg': p.selected > -1 && index !== p.selected }"
          v-for="(item, index) in filteredModels"
          :key="index"
        >
          <div
            class="mt-0 flex flex-col w-full items-start justify-between gap-5"
          >
            <div class="flex w-full items-center justify-between">
              <div
                class="flex gap-2 transition-all ease-in duration-200"
                :class="{ '!rounded-bl-none': index === p.selected }"
              >
                <span
                  @click="handleModelSelect(index, item)"
                  class="cursor-pointer"
                >
                  <img
                    src="@/assets/icons/svg/worksheet/PlusTable.svg"
                    v-if="index !== p.selected"
                  />
                  <img
                    src="@/assets/icons/svg/worksheet/Plus.svg"
                    v-if="index === p.selected"
                  />
                </span>
                <span>{{ item.modelName || "-" }}</span>
              </div>
              <div>
                <p>{{ item.availability || "-" }} available suites</p>
              </div>
            </div>
            <div class="mt-3.5 flex w-full items-stretch justify-between gap-1">
              <div class="flex w-1/2 flex-col items-stretch">
                <div class="text-sm text-mainBlack-300">Type</div>
                <div class="mt-0 whitespace-nowrap text-base text-black">
                  {{ item.specDescription || "-" }}
                </div>

                <div class="mt-6 text-sm text-mainBlack-300">Bathrooms</div>
                <div class="mt-0 text-base text-black">
                  {{ item.bathroom || "-" }}
                </div>
              </div>
              <div class="flex w-1/2 flex-col items-stretch">
                <div class="text-sm text-mainBlack-300">Area</div>
                <div class="mt-0 whitespace-nowrap text-base text-black">
                  {{ item.area || "-" }}
                </div>

                <div class="mt-6 text-sm text-mainBlack-300">Price</div>
                <div class="mt-0 text-base text-black">
                  {{
                    item?.initial_price?.toLocaleString("en-CA", {
                      style: "currency",
                      currency: "CAD",
                    }) || "-"
                  }}
                </div>
                <!-- <div class="mt-0 text-base text-black">-</div> -->
              </div>
            </div>
          </div>
          <div
            v-if="index === p.selected"
            class="!w-full !border-t !border-qooWhite-60 mt-3"
          >
            <div class="!pt-0 w-full !rounded-[10px] !rounded-t-none">
              <div
                class="grid w-full grid-cols-1 gap-2 flex-wrap !pt-4 !border-t !border-qooWhite-2"
              >
                <div
                  class="bg-qooWhite-5 rounded-lg px-2 py-3 w-full"
                  v-for="(i, j) in item.units"
                  :key="j + '-unit'"
                >
                  <ul class="flex items-center justify-between flex-wrap">
                    <li>
                      <div class="text-xs text-mainBlack-300">Suite:</div>
                      <div class="text-sm">{{ i.name }}</div>
                    </li>
                    <li>
                      <div class="text-xs text-mainBlack-300">Orientation:</div>
                      <div class="text-sm">{{ i.orientations }}</div>
                    </li>
                    <li>
                      <div class="text-xs text-mainBlack-300">Price:</div>
                      <div class="text-sm">
                        {{
                          item.price?.toLocaleString("en-US")
                            ? "$" + item.price?.toLocaleString("en-US")
                            : "-"
                        }}
                        <!-- - -->
                      </div>
                    </li>
                    <li class="min-w-[105px] text-center">
                      <!-- <lightBtn
                        @clickBtn="addWSH(item.modelId, i.suiteId)"
                        classList="px-4 py-2 w-full text-center"
                        :text="
                          worksheetId.findIndex(
                            (worksheet) =>
                              worksheet.Mid === item.modelId &&
                              worksheet.Uid === i.suiteId,
                          ) == -1
                            ? 'Add Suite'
                            : 'Remove Suite'
                        "
                      >
                      </lightBtn> -->
                      <EnhancedButton
                        type="outlined"
                        :disabled="UnauthorizedStatus(item.statusDesc)"
                        class="w-[105px] h-[36px] text-[14px] !px-0"
                        :text="
                          UnauthorizedStatus(item.statusDesc)
                            ? 'Add Suite'
                            : !buttonStates[i.suiteId]
                              ? 'Remove Suite'
                              : 'Add Suite'
                        "
                        @click="
                          addWSH(
                            selectedModelForWorksheet.modelId,
                            i.suiteId,
                            item,
                          )
                        "
                      />
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="flex w-full justify-end mt-0">
    <div
      v-if="btnPos != 'top'"
      class="max-md:fixed max-md:bottom-0 max-md:w-full gap-4 max-md:px-9 max-md:border-t max-md:border-mainBlack-300 max-md:bg-white box-border max-md:py-5 max-md:flex max-md:justify-end max-md:items-center z-150"
    >
      <button class="underline md:mr-6" @click="$emit('close')">Cancel</button>
      <button
        class="bg-mainBlack-1000 rounded-[30px] text-white py-3 px-11"
        @click="$emit('save', worksheetId)"
      >
        Save
      </button>
    </div>
  </div>
</template>

<!-- eslint-disable no-undef -->
<script setup>
import lightBtn from "@/components/base/common/lightBtn.vue";
import TableSkeleton from "@/components/ui/TableSkeleton.vue";
import popupHeader from "./popupHeader.vue";
import { ref, onMounted, computed, reactive } from "vue";
import { useModels } from "@/store/models.js";
import { showToast } from "@/util/toast";
import EnhancedButton from "@/components/base/common/EnhancedButton.vue";

let modelsStore = {};
const filteredModels = ref([]);
const sortStyle = ref("Asc");
const sortType = ref("Name");
const buttonStates = reactive({});

const emits = defineEmits(["showDet", "close", "save"]);

const UnauthorizedStatus = (status) => {
  switch (status) {
    case "Available":
      return false;
    // case "Sold":
    // case "Conditional":
    // case "Unavailable":
    // case "Hold":
    // case "Firm":
    // case "Reserved":
    //   return true;
    default:
      return true;
  }
};

const p = defineProps({
  floorplanList: {
    type: Array,
  },
  isTitle: {
    type: Boolean,
    default: true,
  },
  classSelection: {
    type: String,
    default: "",
  },
  btnPos: {
    type: String,
    default: "top",
  },
  selected: {
    type: Number,
    default: -1,
  },
  worksheetList: {
    type: Array,
  },
  worksheetIdLength: {
    type: Number,
    default: 0,
  },
});

const worksheetId = ref([]);
const selectedModelForWorksheet = ref(null);

const getAvailableUnitsCount = computed(() => {
  return (units) => {
    if (!units || !units.length) return "0";
    const availableCount = units.filter(
      (unit) => !UnauthorizedStatus(unit.status),
    ).length;
    return availableCount === 1 ? "1" : `${availableCount}`;
  };
});

const handleModelSelect = (index, item) => {
  selectedModelForWorksheet.value = item;
  selectedModelForWorksheet.value?.units?.forEach((item) => {
    buttonStates[item.suiteId] = !checkAddedToWorksheet(item) ? false : true;
  });
  emits("showDet", index);
};

// const checkAddedToWorksheet = (unit) => {
//   const index = worksheetId.value.findIndex(
//     (worksheet) =>
//       worksheet.Mid === selectedModelForWorksheet.modelId &&
//       worksheet.Uid === unit.suiteId,
//   );
//   return index === -1;
// };

const checkAddedToWorksheet = (unit) => {
  const index = worksheetId.value.findIndex(
      (worksheet) =>
        worksheet.Mid === selectedModelForWorksheet.value.modelId && worksheet.Uid === unit.suiteId,
    )
  return index === -1;
};
const addWSH = (Mid, Uid) => {
  if (
    worksheetId.value.length < 3 ||
    worksheetId.value.findIndex(
      (worksheet) => worksheet.Mid === Mid && worksheet.Uid === Uid,
    ) !== -1
  ) {
    const index = worksheetId.value.findIndex(
      (worksheet) => worksheet.Mid === Mid && worksheet.Uid === Uid,
    );
    if (index !== -1) {
      worksheetId.value.splice(index, 1);
    } else {
      let newWorksheet = {};
      p.floorplanList.forEach((element) => {
        if (element.modelId === Mid) {
          element.units.forEach((e) => {
            if (e.suiteId === Uid) {
              newWorksheet = {
                Mid: element.modelId,
                order: worksheetId.value.length - 1,
                Uid: e.suiteId,
                modelName: element.modelName,
                name: e.suiteName,
                type: element.specDescription,
                price: e.price,
                area: element.modelSize,
                bathroom: element.bathNumber,
                exposure: e.orientationAbbreviation,
              };
            }
          });
        }
      });
      worksheetId.value.push(newWorksheet);
    }
    selectedModelForWorksheet.value?.units?.forEach((item) => {
      buttonStates[item.id] = !checkAddedToWorksheet(item) ? false : true;
    });
  } else
    showToast({
      message: "The maximum number of suites allowed is 3",
      type: "error",
    });
};
const deleteUnit = (data) => {
  const index = worksheetId.value.findIndex((item) => item.Uid === data.Uid);
  if (index !== -1) {
    worksheetId.value.splice(index, 1);
    buttonStates[data.Uid] = true
  }
  return worksheetId.value;
};

const handleCheckboxChange = (e) => {
  showTable.value = e;
};

const getSortType = (e) => {
  sortType.value = e ? "Size" : "Name";
  sortModelsList();
};

const getSortStyle = (e) => {
  sortStyle.value = e ? "Desc" : "Asc";
  sortModelsList();
};

const sortModelsList = (models) => {
  const compare = (a, b) => {
    if (sortType.value === "Name") {
      const nameA = a.modelName.toLowerCase();
      const nameB = b.modelName.toLowerCase();

      return sortStyle.value === "Asc"
        ? nameA.localeCompare(nameB)
        : nameB.localeCompare(nameA);
    } else if (sortType.value === "Size") {
      return sortStyle.value === "Asc"
        ? a.modelSize - b.modelSize
        : b.modelSize - a.modelSize;
    }
  };

  filteredModels.value.sort(compare);
};

const loading = ref(true);
const getFilteredData = (models) => {
  filteredModels.value = models;
  loading.value = false;
  modelsStore.setFilteredData(filteredModels.value);
  sortModelsList();
};

onMounted(() => {
  modelsStore = useModels();
  worksheetId.value = []; //JSON.parse(JSON.stringify(p.worksheetList));
  p.worksheetList.forEach((value, index, array) => {
    let newWorksheet = {};
    p.floorplanList.forEach((element) => {
      if (element.modelId === value.Mid) {
        element.units.forEach((e) => {
          if (e.suiteId === value.Uid) {
            newWorksheet = {
              Mid: element.modelId,
              order: worksheetId.value.length - 1,
              Uid: e.suiteId,
              modelName: element.modelName,
              name: e.suiteName,
              type: element.specDescription,
              price: e.price,
              area: element.modelSize,
              bathroom: element.bathNumber,
              exposure: e.orientationAbbreviation,
            };
          }
        });
      }
    });
    worksheetId.value.push(newWorksheet);
  });
  selectedModelForWorksheet.value = p.floorplanList[p.selected];
  selectedModelForWorksheet.value?.units?.forEach((item) => {
    buttonStates[item.suiteId] = !checkAddedToWorksheet(item) ? false : true;
  });
});
</script>

<style lang="scss" scoped>
@keyframes slideIn {
  0% {
    width: 200px;
    height: 60px;
  }

  100% {
    width: 384px;
    height: 50vh;
  }
}

@keyframes slideOut {
  0% {
    width: 384px;
    height: 50vh;
    display: block;
  }

  100% {
    width: 200px;
    height: 60px;
    display: none;
  }
}

.slideOut {
  display: none;
}

.filter-container {
  animation-duration: 0.5s;
  animation-timing-function: ease-in-out;
}

.filter-container.slideIn {
  animation-name: slideIn;
}

.filter-container.slideOut {
  animation-name: slideOut;
}

.change-bg {
  td {
    // background-color: rgba(246, 246, 246) !important;
    // color: ;
    opacity: 50%;
  }
}

.card {
  .change-bg {
    opacity: 50%;
  }
}

.floorplans.tablePopupWorksheet .vgt-responsive {
  overflow-x: auto !important;
}
</style>
